import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-submit-review',
  templateUrl: './submit-review.component.html',
  styleUrls: ['./submit-review.component.css']
})
export class SubmitReviewComponent implements OnInit {

  reviewForm: any = {
    difficultyLevel: '',
    difficultylevelOptions: {
      'Buffering': false,
      'Internet Issue': false,
      'Test did not load': false,
      'Images did not load': false,
      'Images were not clear': false,
      'Other': false
    },
    feedback: '',
    experience: ''
  };

  review: any = {
    "testtype": "",
    "difficultylevel": [],
    "feedback": "",
    "experience": ""
  }
  constructor(private dialogRef: MatDialogRef<SubmitReviewComponent>, private storage: LocalStorageService) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

  setDifficulty(difficultyLevel: any) {
    this.review.testtype = difficultyLevel;
    this.reviewForm.difficultyLevel = difficultyLevel;
  }

  setExperience(experience: any) {
    this.reviewForm.experience = experience;
  }

  submitReview() {
    let diflops = Object.keys(this.reviewForm.difficultylevelOptions)
    diflops.forEach((diflop: any) => {
      if (this.reviewForm.difficultylevelOptions[diflop] === true) {
        this.review.difficultylevel.push(diflop)
      }
    });
    this.review.feedback = this.reviewForm.feedback;
    this.review.experience = this.reviewForm.experience;
    this.review.difficultylevel.push(this.reviewForm.difficultyLevel);
    this.storage.store('examreview', this.review);
    this.dialogRef.close('submitted');
  }

}
